import "./index.css";
import { useEffect, useState } from "react";
import { useSpeechActivityWatcher } from "../../../../../../Util/hooks/useSpeechActivityWatcher";
import InfoPopupButton from "./InfoPopupButton";
import useTimer from "../../../../../../Util/hooks/useTimer";

const PauseCutoffSlider = ({ audioStream, shouldListenForPause, onFinish }) => {
  const [pauseThreshhold, setPauseThreshhold] = useState(1);
  const [isSpeakingPaused, setIsSpeakingPaused] = useState(false);
  const timer = useTimer();

  const { start: startSpeechActivityWatcher, stop: stopSpeechActivityWatcher } =
    useSpeechActivityWatcher({
      threshold: 0.04,
      smoothingDelay: 500,
      audioStream,
      onSilence: () => setIsSpeakingPaused(true),
      onSpeech: () => setIsSpeakingPaused(false),
    });

  useEffect(() => {
    if (audioStream && shouldListenForPause) {
      startSpeechActivityWatcher();
    } else {
      stopSpeechActivityWatcher();
    }
    return stopSpeechActivityWatcher;
  }, [
    startSpeechActivityWatcher,
    stopSpeechActivityWatcher,
    audioStream,
    shouldListenForPause,
  ]);

  useEffect(() => {
    if (isSpeakingPaused) {
      timer.startTimer();
    } else {
      timer.stopTimer();
      timer.resetTimer();
    }
  }, [isSpeakingPaused, timer]);

  useEffect(() => {
    if (timer.time >= pauseThreshhold) {
      stopSpeechActivityWatcher();
      timer.stopTimer();
      onFinish();
    }
  }, [pauseThreshhold, onFinish, stopSpeechActivityWatcher, timer]);

  return (
    <div className="speakingSectionPauseCutoffWrapper">
      <div className="speakingSectionPauseCutoffLabelWrapper">
        <label className="speakingSectionPauseCutoffLabel">
          Detected Pause Cutoff
        </label>
        <InfoPopupButton />
      </div>
      <div className="speakingSectionPauseCutoffContainer">
        <div className="speakingSectionPauseCutoffSliderBarWrapper">
          <div
            className="speakingSectionPauseCutoffSliderBarDuration"
            style={{
              width: `calc(10% * ${pauseThreshhold})`,
            }}
          />
          <div
            className="speakingSectionPauseCutoffSliderBarProgress"
            style={{
              width: `calc(10% * ${timer.isRunning ? timer.time + 1 : 0})`,
              transitionDuration: `${isSpeakingPaused ? 1 : 0}s`,
            }}
          />
          <div
            className="speakingSectionPauseCutoffSliderBarCaret"
            style={{
              left: `calc(10% * ${pauseThreshhold})`,
            }}
          />
          <input
            type="range"
            min="0"
            max="10"
            step="1"
            value={pauseThreshhold}
            onChange={(e) => {
              if (e.target.value === "0") return;
              setPauseThreshhold(Number(e.target.value));
            }}
            className="speakingSectionPauseCutoffSlider"
          />
        </div>
        <div className="speakingSectionPauseCutoffSliderTickWrapper">
          {["|", "|", "|", "|", "|", "|", "|", "|", "|", "|", "|"].map(
            (value, index) => (
              <p
                key={`slider bar - ${index}`}
                className="speakingSectionPauseCutoffSliderTick"
                style={{ left: `${(value / 11) * 100}%` }}
              >
                {value}
              </p>
            )
          )}
          {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((value) => (
            <p
              key={value}
              className="speakingSectionPauseCutoffSliderTick"
              style={{ left: `${(value / 11) * 100}%` }}
            >
              {value}s
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PauseCutoffSlider;
